import { _axios } from "../axios";
import {AxiosResponse} from "axios";

/**
 * Gets all keywords associated with a product
 *
 * @param productSlug
 * @returns {AxiosResponse<T>}
 */
export function getProductKeywords( productSlug = '' ) {
    return _axios.get( '/products/' + productSlug + '/keywords' );
}

/**
 *
 * @param productSlug
 * @param keyword
 * @returns {AxiosResponse<T>}
 */
export function storeProductKeyword( productSlug = '', keyword = '') {
    return _axios.post('/products/' + productSlug + '/keywords', {keyword: keyword});
}

/**
 *
 * @param productSlug
 * @param keywordSlug
 * @returns {AxiosResponse<T>}
 */
export function destroyProductKeyword( productSlug = '', keywordSlug = '') {
    return _axios.delete('/products/' + productSlug + '/keywords/' + keywordSlug);
}